import 'core-js/modules/es.function.name.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { RadioGroup as RadioGroup$1 } from '@mui/joy';
import classNames from 'classnames';
import 'core-js/modules/es.object.assign.js';
import 'tslib';
import '@cognite/cogs-icons';
import '@cognite/cogs-utils';
import '../../tokens/color-tokens/index.js';
import '../../tokens/elevation-tokens/index.js';
import 'core-js/modules/es.array.concat.js';
import { TextLabel } from '../_technical/text-label/text-label.js';
import 'core-js/modules/es.array.map.js';
import '@mui/base/Button';
import { Message } from '../_technical/message/message.js';
import 'core-js/modules/es.array.push.js';
import '@mui/material';
import '@mui/material/Fade';
import '../config-provider/config-provider.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.array.join.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { Flex } from '../flex/flex.js';

/**
 * RadioGroup
 * =============================================================================
 * This is the wrapper for the Radio component. This wrapper improves
 * accessibility of the Radio fundamentally. It also handles the logic and
 * allows you to add a label.
 *
 * [Open docs »](https://cognitedata.github.io/cogs.js/?path=/docs/components-button--base)
 *
 * -----------------------------------------------------------------------------
 * Examples
 * -----------------------------------------------------------------------------
 * ```
 * <Radio name="radio" checked>
 *   Off
 * </Radio>
 * ```
 *
 * -----------------------------------------------------------------------------
 * Properties
 * -----------------------------------------------------------------------------
 * @param label         - Add a label above the RadioGroup
 * @param name          - Name attribute of the field
 * @param onChange      - Callback fired when a radio button is selected.
 * @param direction     - Render the checkboxes horizontally, or vertically
 * @param value         - Current value of the RadioGroup
 * @param defaultValue  - Default value of the RadioGroup
 * @param status        - Color of helperText defaults to error
 * @param helpText      - Help text for RadioGroup
 *
 * [Read the full documentation »](https://cognitedata.github.io/cogs.js/?path=/docs/components-button--base)
 */
var RadioGroup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    defaultValue = _ref.defaultValue,
    label = _ref.label,
    name = _ref.name,
    _onChange = _ref.onChange,
    _ref$direction = _ref.direction,
    direction = _ref$direction === undefined ? 'vertical' : _ref$direction,
    value = _ref.value,
    status = _ref.status,
    helpText = _ref.helpText;
  var identifier = "cogs-radio-group__" + name + (value ? "-" + value : '');
  var labelIdentifier = identifier + "__label";
  return jsxs(RadioGroup$1, {
    name: name,
    value: value,
    "aria-labelledby": labelIdentifier,
    "aria-activedescendant": identifier,
    onChange: function onChange(event) {
      return _onChange && _onChange(event, value);
    },
    ref: ref,
    defaultValue: defaultValue,
    className: classNames('cogs-v10', 'cogs-radio-group', identifier, className),
    children: [label && jsx(TextLabel, {
      className: classNames('cogs-v10', 'cogs-radio-group__label', labelIdentifier, className),
      id: labelIdentifier,
      htmlFor: labelIdentifier,
      text: label
    }), jsxs(Flex, {
      gap: direction === 'horizontal' ? 16 : 8,
      direction: direction === 'horizontal' ? 'row' : 'column',
      children: [helpText && jsx(Message, {
        text: helpText,
        appearance: status || 'error'
      }), children]
    })]
  });
});

export { RadioGroup };
